import { PropsWithChildren } from 'react';
import { Row } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import { SuperTooltipTemplateId } from '@client/new/components/SuperTooltip/generated';

export const FormLabelSuperTooltip = (
  p: PropsWithChildren<{
    templateId: SuperTooltipTemplateId;
    required?: boolean;
  }>,
) => (
  <Row gap="m" alignCenter className={sprinkles({ marginBottom: 'xs' })}>
    <Typography variant="body" size="medium">
      {p.children}
      {p.required ? (
        <span className={sprinkles({ color: 'ERROR-100' })}>&nbsp;*</span>
      ) : null}
    </Typography>
    <SuperTooltip templateId={p.templateId} />
  </Row>
);
